import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";

export type AggridTooltipProps = {
  text: string;
  children: React.ReactElement;
  _className?: string;
  disabled?: boolean;
};

function AggridTooltip(props: AggridTooltipProps) {
  const { text, children, _className, disabled = false } = props;
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const [placement, setPlacement] = useState<"top" | "bottom">("bottom");
  const containerRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    if (disabled) return;
    const rect = containerRef.current?.getBoundingClientRect();
    if (rect) {
      const spaceBelow = window.innerHeight - rect.bottom;
      const place: "top" | "bottom" = spaceBelow < 80 ? "top" : "bottom";
      setPlacement(place);
      setCoords({
        top: place === "bottom" ? rect.bottom + 4 : rect.top - 4,
        left: rect.left + rect.width / 2,
      });
    }
    setVisible(true);
  };

  const handleMouseLeave = () => setVisible(false);

  return (
    <div
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {visible &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: coords.top,
              left: coords.left,
              transform:
                placement === "top"
                  ? "translateX(-50%) translateY(-100%)"
                  : "translateX(-50%)",
              zIndex: 9999,
            }}
          >
            {/* Arrow above content when placement is bottom */}
            {placement === "bottom" && (
              <div className="flex justify-center">
                <div className="w-3 h-3 -mb-1.5 rotate-45 bg-[#f6f9fb]" />
              </div>
            )}

            <div
              className={`p-2 text-sm text-black shadow-lg bg-[#f6f9fb] rounded-md ${
                _className ?? ""
              }`}
            >
              {text}
            </div>

            {/* Arrow below content when placement is top */}
            {placement === "top" && (
              <div className="flex justify-center">
                <div className="w-3 h-3 -mt-1.5 rotate-45 bg-[#f6f9fb]" />
              </div>
            )}
          </div>,
          document.body
        )}
    </div>
  );
}

export default AggridTooltip;
